import get from "lodash/get";

export function authMeSelector(state) {
    return get(state, "authState.me");
}
